import customerApi from '@/api/customer'

const emptyCard = () => ({ found: false, holderId: 0, cardNumber: null, cardIssuedAt: null, programs: [] })

const state = {
  phoneNumber: '',
  card: emptyCard(),
  accounts: [],
  fullName: null,
  loading: false,
  searched: false,
  error: null,
}

const getters = {}

const actions = {
  fetch({ commit }) {
    commit('LOADING')

    return customerApi.getLoyalty((state.phoneNumber || '').trim())
      .then(({ data }) => commit('SET_RESULT', data))
      .catch(error => commit('SET_ERROR', error))
  },
}

const mutations = {
  SET_PHONE(state, value) {
    state.phoneNumber = value
  },

  LOADING(state) {
    state.loading = true
    state.error = null
  },

  SET_RESULT(state, data) {
    state.card = data.card || emptyCard()
    state.accounts = data.accounts || []
    state.fullName = data.fullName
    state.loading = false
    state.searched = true
  },

  SET_ERROR(state, error) {
    const response = error && error.response

    state.error = (response && response.data && (response.data.message || response.data.title))
      || 'Не удалось получить данные из CRM'
    state.card = emptyCard()
    state.accounts = []
    state.loading = false
    state.searched = true
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {},
}
